import React, {useEffect, useState} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {useStyle} from 'src/providers/style';
import moment from 'moment';
import {Checkbox, IconButton} from 'react-native-paper';
import {Colors, Typography} from 'src/styles';
import {useNavigation} from '@react-navigation/native';
import {calculateDuration} from 'src/common-utils/calculateDuration';

const PatientClaimSessionsItem = ({
  item,
  selectedItems,
  setSelectedItems,
  plans,
  patient,
}: any) => {
  const styles = useStyle();
  const navigation = useNavigation();
  const [amount, setAmount] = useState<string>('');
  const [units, setUnits] = useState<any>('');

  const sortedCpt = item.cpt.sort((a, b) => a - b);

  const durationInMins = calculateDuration(
    item.editedStartTimestamp,
    item.editedEndTimestamp,
  );

  const calculateAmount = () => {
    let calcUnits =
      sortedCpt.length && sortedCpt.length === 1 && sortedCpt[0] === 'H2012'
        ? Math.floor(durationInMins / 60)
        : Math.round(durationInMins / 15);
    setUnits(calcUnits);
    if (!item.cpt.length || !plans.length) {
      return;
    }

    const feeScheduleMap = plans.reduce((acc, plan) => {
      plan.feeSchedule.forEach(feeSchedule => {
        const {cpt, billingRate, staticRate} = feeSchedule;
        if (!acc[cpt]) {
          acc[cpt] = [];
        }
        acc[cpt].push({
          rate: Number(staticRate || billingRate),
          isStatic: !!staticRate,
        });
      });
      return acc;
    }, {});

    for (const cpt of sortedCpt) {
      const feeSchedules = feeScheduleMap[cpt];
      if (feeSchedules && feeSchedules.length) {
        const {rate, isStatic} = feeSchedules[0];
        const total = isStatic ? rate : rate * calcUnits;
        setAmount(`$${total}`);
        setUnits(isStatic ? 1 : calcUnits);
        return;
      }
    }
  };

  useEffect(() => {
    calculateAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let status = 'missing_values';
  if (item.endTimestamp && !item.submissionTimestamp) {
    status = 'missing_values';
  } else if (item.submissionTimestamp) {
    status = 'completed';
  }

  return (
    <View
      style={[styles.row, styles.padding, styles.width, styles.alignCenter]}>
      {patient?.state !== 'paused' ? (
        <TouchableOpacity
          onPress={() => {
            if (selectedItems.includes(item.id)) {
              setSelectedItems(
                selectedItems.filter(
                  (selected: string) => selected !== item.id,
                ),
              );
            } else {
              setSelectedItems([...selectedItems, item.id]);
            }
          }}
          style={[styles.row, styles.alignCenter, styles.marginRight]}>
          <Checkbox.Android
            status={selectedItems.includes(item.id) ? 'checked' : 'unchecked'}
            color={Colors.RAVEN_BLACK}
            uncheckedColor={Colors.RAVEN_BLACK}
          />
        </TouchableOpacity>
      ) : (
        <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
          <Checkbox.Android
            disabled={true}
            status={selectedItems.includes(item.id) ? 'checked' : 'unchecked'}
            color={Colors.RAVEN_BLACK}
            uncheckedColor={Colors.RAVEN_BLACK}
          />
        </View>
      )}
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>
          {moment(item.sessionDate).format('MM/DD/YYYY')}
        </Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>
          {`${moment(item.editedStartTimestamp).format('hh:mm A')} - ${moment(
            item.editedEndTimestamp,
          ).format('hh:mm A')}`}
        </Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>
          {item.cpt.join(', ')}
        </Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>
          {item.location}
        </Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>{units}</Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={[Typography.P3, styles.textColorPrimary]}>{amount}</Text>
      </View>
      <IconButton
        color={Colors.RAVEN_BLACK}
        icon={'eye'}
        onPress={() => {
          if (status === 'missing_values') {
            navigation.navigate('SessionMessage', {
              id: item.id,
            });
          } else {
            navigation.navigate('SessionRecap', {
              id: item.id,
            });
          }
        }}
      />
    </View>
  );
};

export default PatientClaimSessionsItem;
